export default "__VITE_ASSET__BVsLJmbw__"